<!-- 代码结果流程：
    1、初始化图标对象 initChart
	2、获取数据 getData
	3、处理数据更新图表 updateChart
	4、分辨率适配 screenAdapter
	
	图表基本功能实现： 1、数据获取  2、数据处理  3、图表的设置
	
-->

<template>
	<div class="com-container">
		<div class="com-chart" ref="stock_ref"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chartInstance: null, // echart实例对象
				currentIndex: 0, // 当前显示的数据的页数  第0页
				timerId: null, // 定时器的标识
				// allData: null, // 从服务器中获取的所有数据
				allData: [{
					"name": "IPhone 11",
					"stock": 2310,
					"sales": 2103
				}, {
					"name": "长筒靴系带",
					"stock": 34312,
					"sales": 23509
				}, {
					"name": "打底毛衣宽松",
					"stock": 22140,
					"sales": 12830
				}, {
					"name": "厚款羽绒服",
					"stock": 10842,
					"sales": 5492
				}, {
					"name": "牛仔裤",
					"stock": 68102,
					"sales": 44043
				}, {
					"name": "加厚卫衣",
					"stock": 12032,
					"sales": 8603
				}, {
					"name": "衬衫",
					"stock": 9890,
					"sales": 8960
				}, {
					"name": "HUAWEI P30",
					"stock": 20130,
					"sales": 12302
				}, {
					"name": "手机壳",
					"stock": 89342,
					"sales": 42948
				}, {
					"name": "打底裤",
					"stock": 5034,
					"sales": 1220
				}],

			}
		},
		mounted() {
			this.initChart()
			this.getData()
			window.addEventListener('resize', this.screenAdapter) // 分辨率的适配
			this.screenAdapter() // 主动调一次各种尺寸的计算
		},
		destroyed() {
			window.removeEventListener('resize', this.screenAdapter) // 取消监听
			clearInterval(this.timerId)
		},
		methods: {
			initChart() { // 初始化实例对象的方法
				this.chartInstance = this.echarts.init(this.$refs.stock_ref, 'chalk')
				const initOption = {
					title: {
						text: '▎库存和销量分析',
						left: 20,
						top: 20
					}
				}
				this.chartInstance.setOption(initOption)
				// 监听鼠标
				this.chartInstance.on('mouseover', () => {
					clearInterval(this.timerId)
				})
				this.chartInstance.on('mouseout', () => {
					this.startInterval()
				})
			},
			getData() {
				// this.getRequest('/work_log/header_index1').then(resp => {
				// 	if (resp) {
				// 		this.allData = resp.data
				this.updateChart() // 更新图表
				this.startInterval()
				// 	}
				// })
			},
			updateChart() { //处理数据  更新数据
				// 5个圆环中心点坐标
				const centerArr = [
					['18%', '40%'],
					['50%', '40%'],
					['82%', '40%'],
					['34%', '75%'],
					['66%', '75%']
				]
				const colorArr = [ // 用于销量的渐变颜色
					['#4FF778', '#0BA82C'],
					['#E5DD45', '#E8B11C'],
					['#E8821C', '#E55445'],
					['#5052EE', '#AB6EE5'],
					['#23E5E5', '#2E72BF']
				]
				// 处理图表需要的数据
				const start = this.currentIndex * 5
				const end = (this.currentIndex + 1) * 5
				// const showData = this.allData.slice(0, 5) // 截取前5个数据 第0个~第4个   5个圆饼
				const showData = this.allData.slice(start,
					end
				) // 当 this.currentIndex=0 时 （0,5）;   当 this.currentIndex=1 时 （5,10）  搞个定时器让 this.currentIndex 值不断变化
				const seriesArr = showData.map((item, index) => {
					return {
						type: 'pie',
						// radius: [124.4, 110.6], // 半径给两个值（内圆半径，外圆半径），就将圆饼变圆环
						hoverAnimation: false, // 关闭鼠标移入到饼图时的动画效果 
						labelLine: {
							show: false // 隐藏指示线
						},
						center: centerArr[index], // 5个圆环中心点坐标
						label: { // 文字
							position: 'center', // 将 下面 data: name 的文字显示在圆环中心
							color: colorArr[index][0]
						},
						data: [ // 每一个圆饼数据数组有两个对象 一个库存，另一个销量     2个区域
							{
								name: item.name + '\n\n' + item.sales, // 文字内容
								value: item.sales, //  图形圆环的销量 (图形长度)
								itemStyle: { //销量设置成渐变颜色
									color: new this.echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: colorArr[index][0]
										},
										{
											offset: 1,
											color: colorArr[index][1]
										}
									])
								}
							},
							{
								// name: '不显示',
								value: item.stock, //  图形圆环的库存  (图形长度)
								itemStyle: {
									color: '#333843' // 库存设成灰色
								}
							}
						]
					}
				})
				const dataOption = {
					// series: [{}]
					series: seriesArr
				}
				this.chartInstance.setOption(dataOption)
			},
			screenAdapter() {
				// this.titleFontSize = this.$refs.stock_ref.offsetWidth / 100 * 3.6
				const titleFontSize = this.$refs.stock_ref.offsetWidth / 100 * 3.6
				const innerRadius = titleFontSize * 2.8
				const outterRadius = innerRadius * 1.125
				// alert("innerRadius="+innerRadius)
				// alert("outterRadius="+outterRadius)
				const adapterOption = {
					title: { // 标题文字大小
						textStyle: {
							fontSize: titleFontSize
						}
					},
					series: [{
							type: 'pie',
							radius: [outterRadius, innerRadius],
							label: {
								fontSize: titleFontSize / 2
							}
						},
						{
							type: 'pie',
							radius: [outterRadius, innerRadius],
							label: {
								fontSize: titleFontSize / 2
							}
						},
						{
							type: 'pie',
							radius: [outterRadius, innerRadius],
							label: {
								fontSize: titleFontSize / 2
							}
						},
						{
							type: 'pie',
							radius: [outterRadius, innerRadius],
							label: {
								fontSize: titleFontSize / 2
							}
						},
						{
							type: 'pie',
							radius: [outterRadius, innerRadius],
							label: {
								fontSize: titleFontSize / 2
							}
						}
					]
				}
				this.chartInstance.setOption(adapterOption)
				this.chartInstance.resize()
			},
			startInterval() {
				if (this.timerId) {
					clearInterval(this.timerId)
				}
				this.timerId = setInterval(() => {
					this.currentIndex++
					if (this.currentIndex > 1) {
						this.currentIndex = 0
					}
					this.updateChart() // 在更改完currentIndex之后 , 需要更新界面
				}, 5000)
			}
		}
	}
</script>

<style>
</style>
